var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addToHomescreen && _vm.event)?_c('section',{staticClass:"wcc section add-to-homescreen"},[_c('Prompt',{directives:[{name:"hammer",rawName:"v-hammer:tap",value:(_vm.prompt),expression:"prompt",arg:"tap"}]})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }